import axios from 'axios';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { notifySessionExpired } from '../app/services/sessionExpirationService';
import { sanitizeErrorForTelemetry, redactString } from './sanitizeError';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY
  }
});

appInsights.loadAppInsights();

const apiService = async (url, method, data, headers) => {
  try {
    const requestOptions = {
      method,
      data,
      headers,
      responseType: headers.responseType,
    };
    const response = await axios(url, requestOptions);

    switch (response.status) {
      case 200:
      case 201:
      case 204:
        return response;
      case 401:
         appInsights.trackTrace({ message: `Authentication failed or user lacks necessary permissions. ${response.status}.` });
        notifySessionExpired();
        throw new Error(`Authentication failed or user lacks necessary permissions.`);
      default:
        appInsights.trackTrace({ message: redactString(`Error: ${response.data.Message}  TagId: ${response.data.CorrelationId}  StatusCode: ${response.data.Code}`)});
        return response;
    }
  } catch (error) {
    if (error.response) {
      // Check for 401 status code which indicates session expiration
      if (error.response.status === 401) {
        notifySessionExpired();
      }
      appInsights.trackException({ exception: sanitizeErrorForTelemetry(error) });
      throw error.response;
    } else if (error.request) {
      appInsights.trackException({ exception: sanitizeErrorForTelemetry(error) });
      throw error.request;
    } else {
      appInsights.trackException({ exception: sanitizeErrorForTelemetry(error) });
      throw error;
    }
  }
};

export default apiService;
